import { useEffect, useState } from "react";
import axios from "axios";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import Sidebar from "../Common/Sidebar";
import CommonValues from "../Common/utils";
import webicon from "../assets/images/browser.png";
import momentumsmalllogo from "../assets/images/MSmallLogo.svg";
import partners from "../assets/images/collaboration.png";
import blog from "../assets/images/blogs.png";
import login from "../assets/images/login.png";
import Loader from "../Common/Loader";
export default function ImportantLinksLandingPage() {
  const [showWideSidebar, setShowWideSidebar] = useState(true);
  const [pagename, setPageName] = useState("links");
  const [linksByCategory, setLinksByCategory] = useState<Record<string, any[]>>(
    {}
  );
  const [loading, setLoading] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState("");

  const onSidebarValueChanged = (value: any) => setShowWideSidebar(value);

  const groupByCategory = (data: any[]) => {
    return data.reduce((acc: Record<string, any[]>, item) => {
      const category = item.category || "Uncategorized";
      if (!acc[category]) acc[category] = [];
      acc[category].push(item);
      return acc;
    }, {});
  };

  useEffect(() => {
    const fetchLinks = async () => {
      setLoading(true);
      try {
        const token = CommonValues.GetToken();
        const response = await axios.get(
          `${process.env.REACT_APP_Alexandria_API}/api/Alexandria/implinks`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const grouped = groupByCategory(response.data.data);
        setLinksByCategory(grouped);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchLinks();
  }, []);

  const filteredLinks = selectedCategory
    ? linksByCategory[selectedCategory]?.filter((link) =>
        link.title.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  const categoryIcons: Record<string, string> = {
    "Momentum AMP": momentumsmalllogo,
    Login: login,
    "Our Partners": partners,
    Bolgs: blog,
    default: webicon,
  };

  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar
        pagename={pagename}
        setPageName={setPageName}
        onSidebarValueChanged={onSidebarValueChanged}
      />

      <div
        className={`flex-grow-1 d-flex flex-column bg-light p-2 mt-4 ${
          showWideSidebar
            ? "main-content-large-width"
            : "main-content-small-width"
        }`}
      >
        <div>
          <h2 className="fw-bold mb-1"> Important Links</h2>
          <p className="text-muted">
            Find key project resources organized 
            here....
          </p>
        </div>

        <Card className="mt-2 p-4 bordered-container shadow-sm">
          {loading ? (
           <div className="d-flex justify-content-center">
                         {" "}
                         <Loader />{" "}
                       </div>
          ) : selectedCategory === null ? (
            <div className="link-grid">
              {Object.keys(linksByCategory).length === 0 && (
                <p>No links found.</p>
              )}
              {Object.entries(linksByCategory).map(([category, links]) => (
                <div
                  key={category}
                  className="link-card clickable-row"
                  onClick={() => setSelectedCategory(category)}
                >
                  <div className="link-inner">
                    <div className="link-icon-wrapper">
                      <img
                        src={
                          categoryIcons[category] || categoryIcons["default"]
                        }
                        alt={category}
                        className="link-icon"
                      />
                    </div>
                    <div className="link-title">{category}</div>
                    <div className="link-meta">
                      {links.length} link{links.length > 1 ? "s" : ""}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div>
              <div className="d-flex justify-content-between align-items-center mb-4">
                <Button
                  label="Back"
                  icon="fa fa-arrow-left"
                  className="p-button curved-button primary-btn"
                  onClick={() => {
                    setSelectedCategory(null);
                    setSearchTerm("");
                  }}
                />
              </div>
              <div className="mb-3 text-purple"> {selectedCategory} Links</div>
              <input
                type="text"
                placeholder="Tell me what you're looking for..."
                className="form-control mb-4"
                style={{ border: "1px solid #770ebdbc", borderRadius: "10px" }}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />

              <div className="d-flex flex-column gap-3">
                {filteredLinks.length === 0 ? (
                  <p className="text-muted">No matching links found.</p>
                ) : (
                  filteredLinks.map((link) => (
                    <div
                      key={link.id}
                      className="info-card dashboard-card avoid-break p-3 border rounded bg-white"
                    >
                      <div className="d-flex flex-column">
                        <div className="fw-semibold">{link.title}</div>
                        <div className="compact-text text-muted">
                          {link.description ||
                            link.discription ||
                            "No description available."}
                        </div>
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="mt-2"
                          style={{
                            color: "#5a2d91",
                            wordBreak: "break-word",
                            fontWeight: 500,
                          }}
                        >
                          {link.url}
                        </a>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          )}
        </Card>
      </div>
    </div>
  );
}